import FloatLabels from "float-labels.js";
var floatLabels;

document.addEventListener("turbolinks:load", function () {
  floatLabels = new FloatLabels(".float-labels", {
    prioritize: "placeholder",
    exclude: ".skip-float-labels",
    style: 2
  });
});